import React, { useState } from 'react';
import { ButtonsContainer } from '../../components/Layout';
import { Button, Spinner } from '../../components/Common';
import ModalContent from '../../components/Common/Modal/ModalContent';
import ModalTitle from '../../components/Common/Modal/ModalTitle';
import ModalHeader from '../../components/Common/Modal/ModalHeader';
import { __ } from '../../services/translation';
import { modal, notifications, apiTable } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import ApiService from '../../services/api-service';
import {
    clearUnsavedChanges,
    createUnsavedFormId,
    updateUnsavedField,
} from '../../services/unsaved-changes';
import './BulkPriceChange.scss';

interface Props {
    selectedIds: string[];
    onSuccess: () => void;
}

const BulkPriceChange = ({ selectedIds, onSuccess }: Props) => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state: ApplicationState) => state.modal);
    const [unsavedFormId] = useState(() => createUnsavedFormId('bulk-price-modal'));
    const [pricePerKg, setPricePerKg] = useState('');

    const updatePricePerKg = (value: string) => {
        setPricePerKg(value);
        updateUnsavedField(
            unsavedFormId,
            'pricePerKg',
            '',
            value,
            __('profile.price_per_kg'),
            'modal'
        );
    };

    const handleConfirm = async () => {
        const value = parseFloat(pricePerKg.replace(',', '.'));
        if (isNaN(value) || value <= 0) {
            dispatch(notifications.errorNotificationText(__('profiles.bulk_price_invalid')));
            return;
        }

        await ApiService.callFetch(
            'PATCH',
            'product/bulk-price',
            () => {
                dispatch(notifications.successNotification('profiles.bulk_price_success'));
                dispatch(apiTable.refreshApiTable());
                clearUnsavedChanges(unsavedFormId);
                dispatch(modal.hideModal());
                onSuccess();
            },
            null,
            { ids: selectedIds, pricePerKg: value }
        );
    };

    return (
        <ModalContent>
            {loading && <Spinner overlay halfTransparent />}
            <ModalHeader>
                <ModalTitle rawTitle={`${__('profiles.bulk_price_title')} (${selectedIds.length})`} />
            </ModalHeader>
            <div className="bulk-price-change">
                <p className="bulk-price-change__description">
                    {__('profiles.bulk_price_description')}
                </p>
                <div className="bulk-price-change__input-group">
                    <label htmlFor="bulk-price-input">{__('profile.price_per_kg')}</label>
                    <div className="bulk-price-change__input-wrapper">
                        <input
                            id="bulk-price-input"
                            type="text"
                            className="bulk-price-change__input"
                            value={pricePerKg}
                            onChange={(e) => updatePricePerKg(e.target.value)}
                            placeholder="5,50"
                            autoFocus
                        />
                        <span className="bulk-price-change__unit">zł/kg</span>
                    </div>
                </div>
            </div>
            <ButtonsContainer marginTop>
                <Button
                    className="button-modal"
                    click={() => dispatch(modal.hideModal())}
                    text="application.cancel"
                    danger
                    small
                />
                <Button
                    className="button-modal"
                    click={handleConfirm}
                    small
                    text="profiles.bulk_price_confirm"
                    primary
                    disabled={!pricePerKg.trim()}
                />
            </ButtonsContainer>
        </ModalContent>
    );
};

export default BulkPriceChange;
